import { Util } from '@finley-technologies/finley-types';

import {
  LoanFacilityDataGQLType,
  FundingRequestTypeEnumGQLType,
  FundingRequestComponentTypeEnumGQLType,
} from 'types/dashboard-core-gqlTypes.generated.d';

import { z } from 'zod/v4';

// Form State types

export type FundingRequestComponentsState = {
  [originalFundingRequestComponentId: string]: {
    id: string;
    amount: number;
    type: FundingRequestComponentTypeEnumGQLType;
    lenderShareId: string;
    capitalProviderId: string;
    fundTransferDate: Util.FullDateStr | null;
  };
};

export type FundingRequestsFormState = {
  [originalFundingRequestId: string]: {
    id: string;
    totalAmount: number;
    type: FundingRequestTypeEnumGQLType;
    targetFundingDate: Util.FullDateStr;
    components: FundingRequestComponentsState;
  };
};

export type EditLoanFormFields = {
  externalLoanId?: Util.Maybe<string>;
  pricingOptionKey: string;
  maturityDate: Util.FullDateStr;
  fundingRequests: FundingRequestsFormState;
};

export const LoanEditRouteParamsStruct = z.object({
  loanId: z.string({ message: 'Missing URL parameter' }),
});

type LoanActivityStatus =
  | 'approved'
  | 'rejected'
  | 'submitted'
  | 'pending'
  | 'canceled'
  | 'unknown'
  | 'paid';

export type LoanActivity = {
  activityId?: string;
  amount: number;
  effectiveDate: Util.FullDateStr;
  facility: LoanFacilityDataGQLType;
  type: 'Funding Request' | 'Payment';
  isEdited: boolean;
  status: LoanActivityStatus;
};
